import { FormNumberInput } from '@/components/ui/FormFields'
import { FormCheckboxGroup } from '@/components/ui/FormFields/FormCheckboxGroup'
import type {
  PropertyFormInput,
  PropertyFormOutput,
} from '@/schemas/propertySchema'
import { Box, Divider, HStack, SimpleGrid, VStack } from '@chakra-ui/react'
import { Control } from 'react-hook-form'

interface PropertyDetailsStepProps {
  control: Control<PropertyFormInput<boolean>, any, PropertyFormOutput<boolean>>
}

export function PropertyDetailsStep({ control }: PropertyDetailsStepProps) {
  return (
    <HStack spacing={6} align="stretch" className="max-h-full">
      <VStack>
        <SimpleGrid columns={{ base: 1 }} spacing={4}>
          <FormNumberInput
            name="bedrooms"
            label="Quartos"
            control={control}
            isRequired
            min={1}
            max={20}
          />

          <FormNumberInput
            name="bathrooms"
            label="Banheiros"
            control={control}
            isRequired
            min={1}
            max={20}
          />

          <FormNumberInput
            name="max_guests"
            label="Máx. Hóspedes"
            control={control}
            isRequired
            min={1}
            max={50}
          />

          <FormNumberInput
            name="beds"
            label="Camas"
            control={control}
            min={0}
            max={50}
          />
        </SimpleGrid>
      </VStack>
      <Box>
        <Divider orientation="vertical" opacity={1} />
      </Box>
      <VStack w={'full'} justify={'flex-start'} className="max-h-full">
        <FormCheckboxGroup
          control={control}
          name="amenities"
          label="Amenities do anúncio"
        />
      </VStack>
    </HStack>
  )
}
